export class OrderPayDetail{
    id: number;
    bank: number;
    agency: string;
    account: string;
    doc: string;
    date: string;
}